.cb{display:inline-flex;}